
import { useParams } from "react-router-dom";
import { LayoutInvetrario } from "../../layouts"
import { TablaReporteInventario } from "../components"
import { useListReporteXStock } from "../../../hooks/cache";
import { CargandoMedio } from "../../components";




export const ReportesInventario = () => {


    const { id } = useParams();
    const { data, isLoading, chagePage, page } = useListReporteXStock(id);


    return (

        <LayoutInvetrario titulo='Historial de Inventario' add={false}>
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando información de movimiento de historial..." />
            :   <>
                <TablaReporteInventario data={data || []} chagePage={chagePage} page={page} /> 
                </>
            }
        </LayoutInvetrario>


    )
}
